import * as ko from 'knockout';

import * as dimensionMetasApi from '../api/dimension_metas';
import i18n from '../i18n';
import { translate } from '../i18n_text';

const template = require('raw-loader!../../templates/components/include_columns_picker.html')
  .default;

interface IncludeColumnsPickerParams {
  includeSiteId: ko.Observable<boolean>;
  includeSiteCoords: ko.Observable<boolean>;
  includeCustomerName: ko.Observable<boolean>;
  includeProtocol: ko.Observable<boolean>;
  includeOwner: ko.Observable<boolean>;
  includePhotoDescriptions: ko.Observable<boolean>;
  siteAttributeMetas: ko.MaybeSubscribable<dimensionMetasApi.AttributeMetaData[]>;
  selectedSiteAttributeIds: ko.ObservableArray<number>;
}

interface SiteAttributeOption {
  id: number;
  name: string;
  htmlId: string;
}

class IncludeColumnsPicker {
  private static nextInstanceId = 0;

  isOpen = ko.observable(false);
  placeholder = i18n.t('None')();

  includeSiteId: ko.Observable<boolean>;
  includeSiteCoords: ko.Observable<boolean>;
  includeCustomerName: ko.Observable<boolean>;
  includeProtocol: ko.Observable<boolean>;
  includeOwner: ko.Observable<boolean>;
  includePhotoDescriptions: ko.Observable<boolean>;
  selectedSiteAttributeIds: ko.ObservableArray<number>;
  attributeOptions: ko.PureComputed<SiteAttributeOption[]>;
  summary: ko.PureComputed<string>;
  selectedCount: ko.PureComputed<number>;

  private readonly instanceId: number;
  private readonly siteAttributeMetas: ko.MaybeSubscribable<
    dimensionMetasApi.AttributeMetaData[]
  >;

  constructor(params: IncludeColumnsPickerParams) {
    this.instanceId = IncludeColumnsPicker.nextInstanceId++;
    this.includeSiteId = params.includeSiteId;
    this.includeSiteCoords = params.includeSiteCoords;
    this.includeCustomerName = params.includeCustomerName;
    this.includeProtocol = params.includeProtocol;
    this.includeOwner = params.includeOwner;
    this.includePhotoDescriptions = params.includePhotoDescriptions;
    this.siteAttributeMetas = params.siteAttributeMetas;
    this.selectedSiteAttributeIds = params.selectedSiteAttributeIds;
    this.attributeOptions = ko.pureComputed(() => this.buildAttributeOptions());
    this.selectedCount = ko.pureComputed(() => this.countSelected());
    this.summary = ko.pureComputed(() => this.buildSummary());
  }

  toggle = () => {
    this.isOpen(!this.isOpen());
  };

  close = () => {
    this.isOpen(false);
  };

  private buildAttributeOptions(): SiteAttributeOption[] {
    const metas = ko.unwrap(this.siteAttributeMetas) || [];
    return metas.map((attributeMeta) => {
      const attributeId = Number(attributeMeta.id);
      return {
        id: attributeId,
        name: translate(attributeMeta.name_json),
        htmlId: `include-columns-picker-${this.instanceId}-attr-${attributeId}`,
      };
    });
  }

  private buildSummary(): string {
    const count = this.selectedCount();
    if (count === 0) return '';
    return i18n.t('{{count}} selected', { count })();
  }

  private countSelected(): number {
    let count = 0;
    if (this.includeSiteId()) count += 1;
    if (this.includeSiteCoords()) count += 1;
    if (this.includeCustomerName()) count += 1;
    count += this.selectedSiteAttributeIds().length;
    if (this.includeProtocol()) count += 1;
    if (this.includeOwner()) count += 1;
    if (this.includePhotoDescriptions()) count += 1;
    return count;
  }
}

ko.components.register('include-columns-picker', {
  viewModel: IncludeColumnsPicker,
  template,
});

export {};
